<template>
  <div>
    <h3 v-if="showTitle">毛利控制表</h3>
    <el-table
      class="data-table"
      :data="marginsheetList"
      border
      :row-class-name="tableRowClassName"
        v-loading="loading"
        :cell-style="cellStyle"
        style="width: 100%;border:1px solid #D3D8DD"
           
            :header-cell-style="{borderColor:'#D3D8DD'}"
    
      >
      <el-table-column prop="itemName" label="名称" header-align="center" align="left" class-name="first-col"></el-table-column>
      <el-table-column
        :formatter="formatMoney"
        prop="inTotalHaveTax"
        label="收入"
        header-align="center" align="center"
      ></el-table-column>
      <el-table-column prop="inTotalTax" label="税率" header-align="center" align="center"></el-table-column>
      <el-table-column
        :formatter="formatMoney"
        prop="inTotal"
        label="未税金额"
        header-align="center" align="center"
      ></el-table-column>
      <el-table-column
        :formatter="formatMoney"
        prop="outTotalHaveTax"
        label="支出"
        header-align="center" align="center"
      ></el-table-column>
      <el-table-column prop="outTotalTax" label="税率" header-align="center" align="center"></el-table-column>
      <el-table-column
        :formatter="formatMoney"
        prop="outTotal"
        label="未税金额"
        header-align="center" align="center"
      ></el-table-column>
      <el-table-column
        :formatter="formatMoney"
        prop="margin"
        label="毛利"
        header-align="center" align="center"
      ></el-table-column>
      <el-table-column
        :formatter="percentMoney"
        prop="marginPercent"
        label="毛利率"
        header-align="center" align="center"
      ></el-table-column>
    </el-table>
  </div>
</template>
<script>
import { Task } from "../../../API/api";
import { thousandSplit } from "../../../util/util";
export default {
  props: {
    projectInfo: Object,
    showTitle:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      marginsheetList: [],
       loading: false,
    };
  },
  methods: {
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        // 指定列号
        return 'padding:10px;borderColor:#D3D8DD'
      } else {
        return 'borderColor:#D3D8DD'
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.level === "1") {
        return "primary-color";
      } else if (row.level === "2") {
        return "warning-color";
      } else {
        return "normal-color";
      }
    },
    formatMoney(row, col, money) {
      /* 先转数字固定小数，再转字符加千分位分隔符 */
      const m = parseFloat(money);
      return isNaN(m) ? "/" : thousandSplit(m.toFixed(2) + "");
    },
    percentMoney(row, col, money) {
      return money ? money + "%" : "/";
    },
    MarginSheet() {
      this.loading = true;
      const params = {
        itemRange: 1, //0是所有的,1的内容少一点
        skipZero:1,
        isExport: false,
        customerId: this.projectInfo.customerId,
        projectId: this.projectInfo.projectId,
        teamId: "",
        fromtime: "",
        totime: "",
        // totime: totime ? totime.substr(0, 10) : "",
      };
      this.$http
        .post(Task.marginsheetproject, this.qs.stringify(params), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        })
        .then((res) => {
          let data = res.data.retData;
          for(let i of data.showList){
              //数据处理
              if(i.level==3){
                  i.itemName='⦁'+i.itemName
              }
              if(i.inTotalTax==''){
                  i.inTotalTax='/'
              }
              if(i.outTotalTax==''){
                  i.outTotalTax='/'
              }
          }
          this.marginsheetList = data.showList;
            this.loading = false;
       
        })
        .catch((res) => {
              this.loading = false;
        });
    },
  },
  mounted() {
    this.MarginSheet();
  },
};
</script>
<style lang="less" scoped>
.el-table td, .el-table th {
    text-align: center;
}

/deep/.main-list th{
border: none;
}
 .el-table td, .el-table th.is-leaf {
  
    border-right: 1px solid #EBEEF5 ;
} 
.data-table {
  margin-top: 10px;
  .first-col{
    padding-left: 20px;
  }
  
 /deep/ .el-table__body-wrapper{
    .el-table__row:first-child{
      text-align: left !important;
    }
  }
 /deep/.primary-color {
  font-weight: bold;
  color: #2d8ef8;
font-size: 16px;
}
 /deep/ .warning-color {
    // background-color: rgba(255, 102, 102, 0.1);
    font-size: 16px;
    font-weight: bold;
color: #495057;
font-style:italic;
  }
  /deep/.normal-color{
font-size: 14px;
  }
  .el-table__header > thead > tr > th {
    background-color: #f5f7fa;
    color: #606256;
  }
  .cell {
    text-align: center;
  }
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  margin-top: 25px;

  .page-input {
    margin: 0 5px;
    .el-input__inner {
      width: 50px;
    }
  }

  .record {
    display: flex;
    margin-right: 100px;
    font-size: 14px;
    color: #868e96;

    .font {
      line-height: 40px;
      white-space: nowrap;
    }
  }
}

.table-pagination {
  .btn-prev,
  .btn-next,
  .number {
    display: inline-block;
    line-height: 1;
    height: 40px;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: 0.1s;
    transition: 0.1s;
    font-weight: 500;
    -moz-user-select: none;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;

    &:hover,
    &.active {
      color: #409eff;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }

    &[disabled] {
      display: none;
    }
  }

  .el-pager {
    margin-left: 10px;

    .number,
    .el-icon-more {
      margin-right: 10px;
    }
  }

  .btn-prev,
  .btn-next {
    span {
      line-height: 1;
    }
  }
}

.ce-report-table {
  margin-top: 20px;
  font-size: 14px;

  .d-table-cell {
    p:nth-of-type(2) {
      font-size: 12px;
    }
  }

  .colorful {
    &:hover {
      td {
        background-color: initial;
      }
    }
  }

  .colorful:nth-child(1),
  .colorful:nth-child(53),
  .colorful:nth-child(54) {
    color: #2d8ef8;

    &:hover td,
    td {
      background-color: rgba(45, 142, 248, 0.1);
    }
  }

  .colorful:nth-child(2),
  .colorful:nth-child(37) {
    color: #ff6666;

    &:hover td,
    td {
      background: rgba(255, 102, 102, 0.1);
    }
  }

  .colorful:nth-child(55),
  .colorful:nth-child(56),
  .colorful:nth-child(57) {
    color: #f5a623;

    &:hover td,
    td {
      background: rgba(255, 159, 1, 0.1);
    }
  }
}
.ivu-input {
  height: 40px;
  font-size: 14px;
}
.ivu-input-icon {
  height: 40px;
  line-height: 40px;
}

&-content {
  box-sizing: border-box;
  color: #495057;

  &-title {
    margin-top: 24px;
    font-size: 14px;
    color: #303030;
  }

  &-table {
    margin-top: 12px;
    border: 1px solid #ced4da;
    font-size: 13px;
    &-tr {
      display: flex;
      flex-wrap: nowrap;
      &:last-child {
        border-bottom: none;
      }
      &-td {
        width: calc(100% - 604px);
        line-height: 40px;
        text-align: center;
        border-right: 1px solid #ced4da;
        flex-shrink: 0;
        &-no_month {
          &-title {
            display: flex;
            border-bottom: 1px solid #ced4da;
            color: #868e96;
            &--primary {
              background-color: #2d8ef8;
              color: #fff;
            }
            &:last-child {
              border-bottom: none;
            }

            span {
              flex: 1;
              border-right: 1px solid #ced4da;
              background: #f8f9fa;

              &:last-child {
                border-right: none;
              }
            }
          }
          &-value {
            > div {
              height: 40px;
              display: flex;
              border-bottom: 1px solid #ced4da;
              span {
                flex: 1;
                border-right: 1px solid #ced4da;

                &:last-child {
                  border-right: none;
                }
              }
            }

            &-bank {
              // padding: 0 10px;
              // height: 39px;
              box-sizing: border-box;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            &--gray {
              // height: 39px;
              box-sizing: border-box;

              background: #f8f9fa;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 0 15px;
              cursor: pointer;
            }
          }
        }
        &-month {
          overflow-x: scroll;
          &-title {
            display: flex;
            color: #868e96;
            span {
              flex: 1;
              min-width: 80px;
              flex-shrink: 0;
              border-right: 1px solid #ced4da;
              background: #f8f9fa;
              border-bottom: 1px solid #ced4da;
              &:last-child {
                border-right: none;
              }
            }
          }
          &-value {
            > div {
              display: flex;
              height: 40px;
              span {
                flex: 1;
                min-width: 80px;
                flex-shrink: 0;
                border-right: 1px solid #ced4da;
                border-bottom: 1px solid #ced4da;
                &:last-child {
                  border-right: none;
                }
              }
            }
          }
          &-total {
            display: flex;
            height: 40px;
            span {
              flex: 1;
              min-width: 80px;
              flex-shrink: 0;
              border-right: 1px solid #ced4da;
              &:last-child {
                border-right: none;
              }
            }
          }
        }
        &:first-child {
          width: 140px;
        }
        &:nth-of-type(2) {
          width: 88px;
        }
        &:nth-of-type(4) {
          width: 88px;
        }
        &:nth-of-type(5) {
          width: 88px;
        }
        &:nth-of-type(6) {
          width: 100px;
        }
        &:nth-of-type(7) {
          width: 100px;
          border-right: none;
        }
      }
    }
  }
}
&-bussines {
  box-sizing: border-box;
  &-title {
    margin-top: 24px;
    font-size: 14px;
    color: #303030;
  }

  &-table {
    margin-top: 12px;
    border: 1px solid #ced4da;
    border-bottom: none;
    font-size: 13px;

    &-tr {
      font-size: 13px;
      color: #495057;
      display: flex;
      flex-wrap: nowrap;
      &-td {
        width: calc(100% - 604px);
        line-height: 40px;
        text-align: center;
        border-right: 1px solid #ced4da;
        flex-shrink: 0;
        &-no_month {
          &-title {
            border-bottom: 1px solid #ced4da;
            background: #f8f9fa;
            color: #868e96;

            &:last-child {
              border-bottom: none;
            }
          }
          &-value {
            display: flex;
            // border-bottom: 1px solid #ced4da;
            &:last-child {
              // border-bottom: none;
              &-left {
                border-bottom: none;
              }
            }
            &-left {
              width: 60px;
              background-color: #f8f9fa;
              flex-shrink: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              border-right: 1px solid #ced4da;
              border-bottom: 1px solid #ced4da;
              // &:last-child {
              //   border-bottom: none;
              // }
            }
            &-right {
              flex: 1 0;
              > div {
                box-sizing: border-box;
                height: 40px;
                border-bottom: 1px solid #ced4da;
                // &:last-child {
                //   border-bottom: none;
                // }
              }
            }
          }
        }
        &-month {
          overflow-x: scroll;
          &-title {
            display: flex;
            color: #868e96;
            span {
              flex: 1;
              min-width: 80px;
              flex-shrink: 0;
              border-right: 1px solid #ced4da;
              background: #f8f9fa;
              border-bottom: 1px solid #ced4da;
              &:last-child {
                border-right: none;
              }
            }
          }
          &-value {
            > div {
              display: flex;
              span {
                flex: 1;
                min-width: 80px;
                flex-shrink: 0;
                border-right: 1px solid #ced4da;
                border-bottom: 1px solid #ced4da;
                height: 40px;
                box-sizing: border-box;

                &:last-child {
                  border-right: none;
                }
              }
            }
          }
          &-total {
            display: flex;
            height: 40px;
            span {
              flex: 1;
              min-width: 80px;
              flex-shrink: 0;
              border-right: 1px solid #ced4da;
              &:last-child {
                border-right: none;
              }
            }
          }
        }
        &:first-child {
          width: 140px;
        }
        &:nth-of-type(2) {
          width: 88px;
        }
        &:nth-of-type(4) {
          width: 88px;
        }
        &:nth-of-type(5) {
          width: 88px;
        }
        &:nth-of-type(6) {
          width: 100px;
        }
        &:nth-of-type(7) {
          width: 100px;
          border-right: none;
        }
      }
    }
  }
}

&-payback {
  box-sizing: border-box;
  &-title {
    margin-top: 24px;
    font-size: 14px;
    color: #303030;
  }

  &-table {
    margin-top: 12px;
    border: 1px solid #ced4da;
    border-bottom: none;
    font-size: 13px;

    &-tr {
      font-size: 13px;
      color: #495057;
      display: flex;
      flex-wrap: nowrap;
      &-td {
        width: calc(100% - 604px);
        // line-height: 40px;
        text-align: center;
        border-right: 1px solid #ced4da;
        flex-shrink: 0;
        &-no_month {
          &-title {
            border-bottom: 1px solid #ced4da;
            background: #f8f9fa;
            color: #868e96;
            height: 40px;
            line-height: 40px;

            &:last-child {
              border-bottom: none;
            }
          }
          &-value {
            > div {
              &:first-child {
                display: flex;
                flex-wrap: nowrap;
              }
              &:last-child {
                line-height: 39px;
                border-bottom: 1px solid #ced4da;
                color: #2d8ef8;
                background: #f8f9fa;
              }
            }
            &:last-child {
              &-left {
                border-bottom: none;
              }
            }
            &-left {
              width: 60px;
              background-color: #f8f9fa;
              flex-shrink: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              border-right: 1px solid #ced4da;
              border-bottom: 1px solid #ced4da;
            }
            &-right {
              flex: 1 0;
              > div {
                > div {
                  height: 40px;
                  display: flex;
                  align-items: center;
                  padding: 0 5px;
                  text-align: left;
                  border-bottom: 1px solid #ced4da;
                }
              }
              &--gray {
                background-color: #f8f9fa;
                cursor: pointer;
                span {
                  margin-right: 10px;
                }
              }
            }
          }

          &-list {
            > div {
              height: 40px;
              line-height: 40px;

              border-bottom: 1px solid #ced4da;
            }
          }
          &-total {
            height: 40px;
            line-height: 40px;

            border-bottom: 1px solid #ced4da;
          }
        }
        &-month {
          overflow-x: scroll;
          &-title {
            display: flex;
            color: #868e96;
            height: 40px;
            line-height: 40px;
            span {
              flex: 1;
              min-width: 80px;
              flex-shrink: 0;
              border-right: 1px solid #ced4da;
              background: #f8f9fa;
              border-bottom: 1px solid #ced4da;
              &:last-child {
                border-right: none;
              }
            }
          }
          &-value {
            > div {
              > div {
                display: flex;
                span {
                  flex: 1;
                  min-width: 80px;
                  flex-shrink: 0;
                  border-right: 1px solid #ced4da;
                  border-bottom: 1px solid #ced4da;
                  height: 40px;
                  line-height: 40px;
                  box-sizing: border-box;

                  &:last-child {
                    border-right: none;
                  }
                }
              }
              // display: flex;
              // span {
              //   flex: 1;
              //   min-width: 80px;
              //   flex-shrink: 0;
              //   border-right: 1px solid #ced4da;
              //   border-bottom: 1px solid #ced4da;
              //   height: 40px;
              //   box-sizing: border-box;

              //   &:last-child {
              //     border-right: none;
              //   }
              // }
            }

            &-total {
              display: flex;
              > span {
                flex: 1;
                min-width: 80px;
                flex-shrink: 0;
                border-right: 1px solid #ced4da;
                border-bottom: 1px solid #ced4da;
                height: 40px;
                line-height: 40px;
                box-sizing: border-box;

                &:last-child {
                  border-right: none;
                }
              }
            }
          }
          &-total {
            display: flex;
            height: 40px;
            span {
              flex: 1;
              min-width: 80px;
              flex-shrink: 0;
              border-right: 1px solid #ced4da;
              &:last-child {
                border-right: none;
              }
            }
          }
        }
        &:first-child {
          width: 140px;
        }
        &:nth-of-type(2) {
          width: 88px;
        }
        &:nth-of-type(4) {
          width: 88px;
        }
        &:nth-of-type(5) {
          width: 88px;
        }
        &:nth-of-type(6) {
          width: 100px;
        }
        &:nth-of-type(7) {
          width: 100px;
          border-right: none;
        }
      }
    }
    &-all {
      line-height: 40px;
      height: 40px;
      border-bottom: 1px solid #ced4da;

      &--company {
        background-color: #2d8ef8;
        color: #fff;
      }
    }
  }
}

.is_editing {
  background: rgba(45, 142, 248, 0.1);
  cursor: pointer;
}

.dialog {
  .title {
    text-align: center;
    font-size: 18px;
    color: #343a40;
  }

  .el-dialog__body {
    padding: 0;
  }

  .content {
    padding: 40px 50px;
    margin: 10px 0;
    border-top: 1px solid #ced4da;
    border-bottom: 1px solid #ced4da;
  }

  .footer {
    text-align: center;
  }
}

.nodata {
  height: 150px;
  line-height: 150px;
  text-align: center;
  font-size: 20px;
}
</style>